import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Clickable from 'components/Common/Clickable/Clickable'
import ModalContext from 'contexts/ModalContext'
import SortOrderInfoModal from './SortOrderInfoModal'

function HotelSearchSortOrderInfo() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const linkText = intl.formatMessage({
    id: 'V-qLdQqAoX7tWB99kBIk',
    defaultMessage: 'How our sort order works',
    description: 'Link text in the hotel search results toolbar that opens a modal explaining how search results are ranked and how paid placements are disclosed',
  })

  const displayModal = useCallback(() => {
    showModal(<SortOrderInfoModal />)
  }, [showModal])

  return (
    <Clickable onClick={displayModal}>
      <BodyTextBlock variant="medium" weight="bold" endIcon={<LineInfoCircleIcon />}>
        {linkText}
      </BodyTextBlock>
    </Clickable>
  )
}

export default HotelSearchSortOrderInfo
